import React from 'react';

const testimonials = [
  {
    text: 'Why we are the best medical and home care service provider.',
    author: 'Sarina Smith',
    role: 'Designer',
    content:
      'It is a long established fact that a reader will be distracted by the readable established fact that content of a page when looking at its layout. The point of using Lorem Ipsum established fact that a reader. The point of using Lorem Ipsum.'
  },
  {
    text: 'Why we are the best medical and home care service provider.',
    author: 'Sarina Smith',
    role: 'Designer',
    content:
      'It is a long established fact that a reader will be distracted by the readable established fact that content of a page when looking at its layout. The point of using Lorem Ipsum established fact that a reader. The point of using Lorem Ipsum.'
  },
  {
    text: 'Why we are the best medical and home care service provider.',
    author: 'Sarina Smith',
    role: 'Designer',
    content:
      'It is a long established fact that a reader will be distracted by the readable established fact that content of a page when looking at its layout. The point of using Lorem Ipsum established fact that a reader. The point of using Lorem Ipsum.'
  }
];

const Testimonials = () => {
  return (
    <div className="client2-main-wrapper float_left">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-xl-4 col-lg-4 d-xl-block d-lg-block d-none">
            <div className="client-img">
              <img src="images/client2-img.png" alt="Client" />
            </div>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12 col-12">
            <div className="slider-section">
              <div className="page-2-heading mb-2 mt-5">
                <h4 className="text-color text-start set-margin">
                  Our <span>Client's</span>
                </h4>
              </div>
              <div className="owl-carousel owl-theme">
                {testimonials.map((item, index) => (
                  <div className="item" key={index}>
                    <h4 className="mt-5 mb-3 resp-font-size">{item.text}</h4>
                    <a href="#" className="my-3 d-inline-block">
                      {item.author} <small>({item.role})</small>
                    </a>
                    <p className="mt-2">{item.content}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
